import { queries } from "../../shared/queries";
import { routes, useRouteMatch } from "../lib/urls";
import { useHasAccess } from "./useHasAccess";
import { useCurrentUserId } from "./useCurrentUserId";
import { useQuery } from "./useQuery";

export function useAdminViewSubject(): string | null {
  const currentUserId = useCurrentUserId();
  const canReadChats = useHasAccess("tenant:personal_chats_read");
  const canReadSpaces = useHasAccess("tenant:spaces_read");

  const [onChats, chatsMatch] = useRouteMatch(routes.chats);
  const chatUserId = (chatsMatch as { userId?: string }).userId;

  const [, spaceMatch] = useRouteMatch(routes.space);
  const spaceId = (spaceMatch as { spaceId?: string }).spaceId ?? "";
  const [activeSpace] = useQuery(
    spaceId ? queries.navSpace({ spaceId }) : null
  );

  if (canReadChats && onChats && chatUserId && chatUserId !== currentUserId) {
    return chatUserId;
  }

  const owner = activeSpace?.roleGrantsAsScope[0]?.user;
  if (
    canReadSpaces &&
    activeSpace?.mode === "personal" &&
    owner &&
    owner.id !== currentUserId
  ) {
    return owner.id;
  }

  return null;
}
